import { render, staticRenderFns } from "./Lavazza.vue?vue&type=template&id=2afec044&scoped=true&"
import script from "./Lavazza.vue?vue&type=script&lang=js&"
export * from "./Lavazza.vue?vue&type=script&lang=js&"
import style0 from "./Lavazza.vue?vue&type=style&index=0&id=2afec044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afec044",
  null
  
)

export default component.exports